import { View } from '../types/common.js';

// BREAKPOINTS
// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/Web-Component-Library?type=design&node-id=10681-324
const MAX_TABLET_WIDTH = 1023;
const MAX_MOBILE_WIDTH = 460;
function getView(width) {
  if (width <= MAX_MOBILE_WIDTH) {
    return View.mobile;
  }
  if (width <= MAX_TABLET_WIDTH) {
    return View.tablet;
  }
  return View.desktop;
}

export { getView };
